import { render, staticRenderFns } from "./ListEmpty.vue?vue&type=template&id=2c4606b9&scoped=true&lang=pug&"
import script from "./ListEmpty.vue?vue&type=script&lang=js&"
export * from "./ListEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ListEmpty.vue?vue&type=style&index=0&id=2c4606b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4606b9",
  null
  
)

export default component.exports